import {ItemScannerGlobalReducer} from '../../itemDetails/reducer';
import {batchDetailsReducer} from '../../batchDetails/reducer';
import {driverReducer} from '@buncha/driver/reducer';
import {homeReducer} from '../../home/reducer';
import {localizationReducer} from '@buncha/localization/reducer';
import {onBoardingReducer} from '../../onBoarding/reducer';

export default {
  home: homeReducer,
  onboarding: onBoardingReducer,
  batchDetail: batchDetailsReducer,
  itemScanner: ItemScannerGlobalReducer,
  driver: driverReducer,
  localization: localizationReducer,
};
